import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ParametersService, ParamType } from '@app/core/parameters';
import { IPatientRequestTest } from '@app/core/patient-requests';

@Component({
  selector: 'afoone-request-tests-list',
  templateUrl: './request-tests-list.component.html',
  styleUrls: ['./request-tests-list.component.css'],
})
export class RequestTestsListComponent {
  @Input() public tests: IPatientRequestTest[];
  @Input() public colors: string[];
  /** Si true, se muestra columna de checkbox para seleccionar técnicas para acumulados (issue 533). */
  @Input() public showAcumuladosSelection = false;
  /** Técnicas seleccionadas para acumulados (solo lectura; cambios vía selectedForAcumuladosChange). */
  @Input() public selectedForAcumulados: IPatientRequestTest[] = [];
  @Output() public selectedForAcumuladosChange = new EventEmitter<IPatientRequestTest[]>();

  public WIDTH = { RANGOS: '130px', RESULTADOS: '40%' };

  constructor(private _parametersService: ParametersService) {
    this._parametersService
      .getParameters([
        ParamType.ColorPatologico,
        ParamType.ColorAlarma,
        ParamType.ColorExtremo,
      ])
      .subscribe((p) => {
        this.colors = p.map((prm) => prm.value);
      });
  }

  isHeader(test: IPatientRequestTest): boolean {
    return !test.mikrotyp && [10, 12, 13].includes(test.restyp);
  }

  isComment(test: IPatientRequestTest): boolean {
    // if it is the first test in the list, it is not a comment
    if (this.tests.indexOf(test) === 0) {
      return false;
    }
    // if metname it is the same as the previous test, it is a comment
    return test.metname === this.tests[this.tests.indexOf(test) - 1].metname;
  }

  getIconTypeForP(test: IPatientRequestTest): IconType {
    return {
      show: [1, 2, 3, 4, 5, 6].includes(test.pat),
      direction: [1, 3, 5].includes(test.pat) ? 'down' : 'up',
      color: [1, 2].includes(test.pat)
        ? this.colors[0]
        : [3, 4].includes(test.pat)
        ? this.colors[1]
        : this.colors[2],
    };
  }

  isSelectedForAcumulados(test: IPatientRequestTest): boolean {
    return this.selectedForAcumulados?.some((t) => t.metodo === test.metodo) ?? false;
  }

  toggleAcumuladosSelection(test: IPatientRequestTest): void {
    if (!this.showAcumuladosSelection || this.isHeader(test) || this.isComment(test)) return;
    const current = this.selectedForAcumulados ?? [];
    const isSelected = current.some((t) => t.metodo === test.metodo);
    let next: IPatientRequestTest[];
    if (isSelected) {
      next = current.filter((t) => t.metodo !== test.metodo);
    } else {
      next = [...current, test];
    }
    this.selectedForAcumuladosChange.emit(next);
  }
}

type IconType = {
  show: boolean;
  direction: 'up' | 'down';
  color: string;
};
